import { Map } from 'immutable';
import { TARGET_LIST } from '@constants/actions';

const initialState = Map({
  targetLists: []
});

const TargetList = (state = initialState, action) => {
  switch (action.type) {
    case TARGET_LIST.POPULATE:
      const targetLists = action.payload.targetLists;
      return state.set('targetLists', targetLists);
    default:
      return state;
  }
};

export default TargetList;